<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item" @click="switchTab('payment')">PAYMENT SETTINGS</div>
        <div class="h-spacer"></div>
        <div class="tab-item active" @click="switchTab('announcement')">
          ANNOUNCEMENT
        </div>
        <div class="h-spacer" v-if="false"></div>
        <div class="tab-item" v-if="false" @click="switchTab('static_content')">
          STATIC CONTENT
        </div>
      </div>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="addNew()">ADD ANNOUNCEMENT</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_announcement && announcement_data.length > 0" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Subject</th>
              <th>Report</th>
              <th>Status</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in announcement_data" :key="index">
              <td @click="selectAnnouncement(item)">{{ `${item.subject}` }}</td>
              <td @click="selectAnnouncement(item)">
                {{ item.viewed_user }}/{{ item.total_user }}
              </td>
              <td @click="selectAnnouncement(item)">
                <b-tag v-if="item.status == 'published'" type="is-success">Published</b-tag>
                <b-tag v-if="item.status == 'pending'" type="is-warning">Pending</b-tag>
              </td>
              <td>
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>
                  <b-dropdown-item @click="updateAnnouncement(item)" aria-role="listitem">Update</b-dropdown-item>
                  <b-dropdown-item @click="deleteAnnouncement(item)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="loading_announcement" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Subject</th>
              <th>Message</th>
              <th>Report</th>
              <th>Status</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="rigth-panel" v-if="selected_announcement">
        <div class="media-panel-content" v-if="selected_announcement.type == 'video'"
          v-html="selected_announcement.video"></div>
        <div class="media-panel-content" v-if="selected_announcement.type == 'image'">
          <img :src="$store.state.ASSETS_BASE_URL +
            '/assets/uploaded/' +
            selected_announcement.image
            " />
        </div>
        <div class="rigth-panel-tile">SUBJECT</div>
        <div class="rigth-panel-content">
          {{ selected_announcement.subject }}
        </div>
        <div class="rigth-panel-tile">MESSAGE</div>
        <div class="rigth-panel-content">
          {{ selected_announcement.message }}
        </div>
      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound title="No announcement selected" subtitle="Select a announcement to see its details">
        </widgetNotfound>
      </div>
    </div>
    <div class="wrapper-footer"></div>

    <!-- Add pricing -->
    <b-modal v-model="show_add_announcement_modal" :id="'sideBar' + $store.state.sidebar">
      <div class="form-modal-widget">
        <div class="form-modal-header">
          <h2 v-if="!form.id">ADD ANNOUNCEMENT</h2>
          <h2 v-else>UPDATE ANNOUNCEMENT</h2>
        </div>
        <div class="form-modal-body">
          <div class="row">
            <b-field style="width: 100%" label="Type">
              <b-select v-model="form.type" expanded>
                <option v-for="(option, index) in announcement_types" :key="index" :value="option.value">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <div class="h-spacer"></div>
            <b-field style="width: 100%" label="Status" expanded>
              <b-select v-model="form.status" expanded>
                <option value="pending">Pending</option>
                <option value="published">Published</option>
              </b-select>
            </b-field>
          </div>

          <b-field v-if="form.type == 'image'" label="Image">
            <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
              location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
              :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image"
              @onFileSelected="onImageSelected">
              <div class="image-upload-widget">Choose Image to upload</div>
            </upload-trigger>
          </b-field>
          <b-field v-if="form.type == 'video'" label="Embed Video">
            <b-input v-model="form.video" maxlength="8000" expanded type="textarea"></b-input>
          </b-field>
          <b-field label="Subject">
            <b-input v-model="form.subject" value=""></b-input>
          </b-field>
          <b-field label="Message">
            <b-input v-model="form.message" maxlength="200" expanded type="textarea"></b-input>
          </b-field>
          <b-field label="Link path">
            <b-input v-model="form.link" value=""></b-input>
          </b-field>
        </div>
        <div class="form-modal-footer">
          <b-button :loading="submit_anouncement_loading" @click="submitAnnouncement()" type="is-primary">SAVE</b-button>
          <div class="h-spacer"></div>
          <b-button @click="show_add_announcement_modal = false" type="is-primary" outlined>CANCEL</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    loading_announcement: false,
    announcement_data: [],
    show_add_announcement_modal: false,
    announcement_types: [
      { name: "None", value: "none" },
      { name: "Image", value: "image" },
      { name: "Video", value: "video" },
    ],
    form: {
      id: null,
      type: "none",
      image: "",
      video: "",
      subject: "",
      message: "",
      link: "",
      status: "pending",
    },
    submit_anouncement_loading: false,
    selected_announcement: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAnnouncement();
  },
  computed: {},
  methods: {
    selectAnnouncement(item) {
      let vm = this;
      vm.selected_announcement = item;
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.image = file;
    },
    deleteAnnouncement(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("SETTINGS_ANNOUNCEMENT_DELETE", { id: item.id })
              .then((response) => {
                vm.getAnnouncement();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    updateAnnouncement(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.subject = item.subject;
      vm.form.message = item.message;
      vm.form.type = item.type;
      vm.form.image = item.image;
      vm.form.video = item.video;
      vm.form.link = item.link;
      vm.form.status = item.status;
      vm.show_add_announcement_modal = true;
    },
    submitAnnouncement() {
      let vm = this;
      vm.submit_anouncement_loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("SETTINGS_ANNOUNCEMENT_ADDNEW", vm.form)
          .then((response) => {
            vm.submit_anouncement_loading = false;
            vm.show_add_announcement_modal = false;
            vm.getAnnouncement();
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_anouncement_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$store
          .dispatch("SETTINGS_ANNOUNCEMENT_UPDATE", vm.form)
          .then((response) => {
            vm.submit_anouncement_loading = false;
            vm.show_add_announcement_modal = false;
            vm.getAnnouncement();
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_anouncement_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    getAnnouncement() {
      let vm = this;
      vm.loading_announcement = true;
      vm.$store
        .dispatch("SETTINGS_ANNOUNCEMENT_GET_ALL")
        .then((response) => {
          vm.loading_announcement = false;
          vm.announcement_data = response.data.return;
        })
        .catch((error) => {
          vm.loading_announcement = false;
          console.log("SETTINGS_ANNOUNCEMENT_GET_ALL", error);
        });
    },
    addNew() {
      let vm = this;
      vm.form = {
        id: null,
        type: "none",
        image: "",
        video: "",
        subject: "",
        message: "",
        link: "",
        status: "pending",
      };
      vm.show_add_announcement_modal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 125px);
    display: flex;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: calc(100% - 550px);
      display: flex;

      @media (max-width: 966px) {
        width: 50%;
      }

      @media (max-width: 700px) {
        width: 55%;
      }

      @media (max-width: 600px) {
        width: 100%;
      }

      .table-widget {
        // height: calc(100% - 60px);
        overflow-y: auto;
        border-radius: 0;

        button.openButton {
          display: none;
          width: fit-content;
          margin: 5px 0 0 5px;

          @media (max-width: 600px) {
            display: flex;
          }
        }

        table {
          width: 100%;

          tr {
            th {
              white-space: nowrap;
            }

            td {
              white-space: nowrap;

              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 550px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      @media (max-width: 966px) {
        width: 50%;
      }

      @media (max-width: 700px) {
        width: 45%;
      }

      @media (max-width: 600px) {
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: 0px;
        transition: .5s;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);

        &.no-data-panel {
          display: none;
        }
      }

      @media (max-width: 485px) {
        width: 90%;
      }

      .media-panel-content {

        img,
        iframe {
          height: 300px !important;
          object-fit: cover;
          width: 100% !important;
        }
      }

      .rigth-panel-tile {
        background: #ddd;
        padding: 10px 20px;
        font-weight: 800;
      }

      .rigth-panel-content {
        padding: 8px 20px;
        margin-bottom: 30px;
      }
    }
  }

  .wrapper-footer {
    height: 65px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }
}

.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

.modal {
  @media (max-width: 500px) {
    padding: 0 !important;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
